module.exports = __webpack_public_path__ + "img/location.4474c1bd.svg";